export default __webpack_public_path__ + "static/media/SS9-min.a02c1d87.png";